/*
 * © 2023 Vertafore, Inc. All rights reserved.
 * Reproduction and distribution without the written permission of Vertafore is prohibited.
 */
import React, { Component, ReactElement } from "react";
import "./valueList.css";
import "../staticQuestions/common.css";
import { ValueList, ValueListItem } from "../../types/customTypes/ratModels";

interface ValueListItemProps {
  valueList: ValueList;
  state: string | undefined;
}

interface ValueListItemState {
  items: ValueListItem[];
}

export default class ValueListItemPopUp extends Component<
  ValueListItemProps,
  ValueListItemState
> {
  constructor(props: ValueListItemProps) {
    super(props);
    this.state = {
      items: props.valueList.items != null ? props.valueList.items : [],
    };
  }

  render = (): ReactElement => {
    return (
      <div>
        <div>
          <p>
            State:{" "}
            {this.props.valueList.state != null
              ? this.props.valueList.state
              : "CW"}
          </p>
          <p>
            Matching Strategy:{" "}
            {this.props.valueList.matchingStrategy != null
              ? this.props.valueList.matchingStrategy
              : "Exact"}
          </p>
        </div>
        <div className="small-header">Value List Items</div>
        <div className="item-list">
          {this.state.items.map((item) => (
            <div
              key={item.id ?? null}
              className="item-list-entry"
              title={JSON.stringify(item)}
            >
              {item.value}
            </div>
          ))}
        </div>
      </div>
    );
  };
}
